<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->


<template>
  <div class="wy-analytics-contact-reasons-detail-topic-messages">
    <div class="topic-group-section-box">
      <div class="topic-group-section">
        <div class="div-group-viewer-header div-group-name">
          Customer messages
        </div>
        <div class="div-group-viewer-content" v-loading="loading">
          <div class="div-group-topics">
            <div class="div-topic-content">
              <div class="div-item" :title="item.messageText" v-for="(item, index) in messages" :key="index"
                v-bind:class="{ selected: (selectedMessageText && selectedMessageText == item.messageText) }"
                @click="getTranscriptByMessageText(item)">
                <div class="div-ellipsis-item">{{ item.messageText }}</div>
                <div class="div-messages-counter">({{ item.counter }})</div>
              </div>
            </div>
          </div>
        </div>
        <div class="div-group-viewer-footer div-group-name">
          <div class="div-message-transcripts-viewer-footer">
            <div class="div-transcript-page-infor">Showing {{ pageItemStart }}-{{ pageItemEnd }}</div>
            <div class="div-transcript-pagination">
              <el-pagination :page-size="pageSize" :page-count="pageCount" :current-page="pageNo" :disabled="loading" prev-text="< Previous"
                next-text="Next >" @current-change="pageChanged" layout="prev, next">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>

      <wy-analytics-transcript-viewer :showTranscriptContent="selectedMessageText" :topicDisplayName="parent.currentItem.topicDisplayName" :topics="parent.currentItem.mergedTopics" :messageText="selectedMessageText" :showPagination="true" :applyGlobalFilter="true" viewName="Messages" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import WyUtils from '../../library/wy-utils.js';
import WyAnalyticsTranscriptViewer from './wy-analytics-transcript-viewer2.vue';

export default Vue.extend({
  name: 'wy-analytics-contact-reasons-detail-topic-messages',
  components: {
    'wy-analytics-transcript-viewer': WyAnalyticsTranscriptViewer
  },
  props: ['parent', 'activeTab'],

  data() {
    return {
      module: this,
      loading: false,
      initDate: null,
      topicData: {},
      messages: [],
      selectedMessageText: null,

      pageNo: 1,
      pageSize: 100,
      pageCount: 1,
      pageItemStart: 0,
      pageItemEnd: 0,
      fetchData: true
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'transcriptInfoReference']),
  },

  methods: {
    ...mapActions(['fetchContactReasonsTopicMessages']),
    ...mapMutations(['updateTranscriptInfoReference']), //handle transcript info

    handleTranscriptPopover() {
      if (this.transcriptInfoReference) {
        this.transcriptInfoReference.visible = false;
        this.updateTranscriptInfoReference(null);
      }
    },

    pageChanged(pageNo) {
      this.fetchData = true;
      this.loadTopicMessages(pageNo);
    },

    startLoading() {
      this.initDate = new Date();
      if (!this.loading) {
        this.logEventLoaded();
      }
      this.loadTopicMessages();
    },

    logEventLoaded() {
      if (this.initDate) {
        this.$store.dispatch('amplitudeLogWithFilters', { name: 'messages_loaded', data: { topic_name: this.topicData.topicDisplayName, data_load_time: WyUtils.getTimeDiff(this.initDate) } });
        this.initDate = null;
      }
    },

    async getTranscriptByMessageText(item) {
      this.selectedMessageText = item.messageText;
    },

    async loadTopicMessages(pageNo = 1) {
      if(this.fetchData) {
        this.fetchData = false;
        this.pageNo = pageNo;
        this.loading = true;
        this.selectedMessageText = null;
        
        if (this.parent.currentItem) {
          this.topicData = this.parent.currentItem;
          this.loading = true;
          let result = await this.fetchContactReasonsTopicMessages({ topics: this.parent.currentItem.mergedTopics, topicDisplayName: this.topicData.topicDisplayName, pageNo: this.pageNo, pageSize: this.pageSize + 1 });

          if (result.data && result.data.messages && result.data.messages.length > 0) {
            if (result.data.messages.length > this.pageSize) {
              this.messages = result.data.messages.slice(0, result.data.messages.length - 1);
              this.pageItemStart = (this.pageNo - 1) * this.pageSize + 1;
              this.pageItemEnd = this.pageItemStart + this.pageSize - 1;
              this.pageCount = this.pageNo + 1;
            }
            else {
              this.messages = result.data.messages;
              this.pageItemStart = (this.pageNo - 1) * this.pageSize + 1;
              this.pageItemEnd = this.pageItemStart + result.data.messages.length - 1;
            }
            await this.getTranscriptByMessageText(this.messages[0]);
          }
          else {
            this.messages = [];
            this.pageNo = 1;
            this.pageItemStart = 0;
            this.pageItemEnd = 0;
          }
          this.loading = false;
        }
        this.parent.stopLoadingByTab('messages');        
      }
      
    },
  },

  mounted() {
    // on resize window, we close the transcript popover
    window.addEventListener('resize', this.handleTranscriptPopover);
    // Outside of metric-analysis
    document.addEventListener('click', () => {
      this.handleTranscriptPopover();
    });
    // Inside metric-analysis
    document.querySelector('.wy-analytics-contact-reasons-detail-topic-messages').addEventListener('click', () => {
      this.handleTranscriptPopover();
    });
  }
});
</script>

<style lang="scss">
.wy-analytics-contact-reasons-detail-topic-messages {
  width: 100%;
  height: calc(100vh - 287px);
  // min-width: 1093px;

  .flex-container {
    display: flex;
    justify-content: space-around;
  }

  .transcripts-viewer-header-right {
    overflow-y: auto;
    height: 204px !important;
    padding-right: 20px;

    &::-webkit-scrollbar {
      background-color: #000 !important;
      width: 8px !important;
    }

    &::-webkit-scrollbar-thumb {
      background: #C8C8C8 !important;
      border-radius: 5px;
    }
  }

  .contact-reason-transcript-tab-info-pop-over {
    padding: 12px 7px 10px 15px !important;
  }

  .sentiment-icon-positive {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_positive_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 67px;
    bottom: 8.5px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .sentiment-icon-neutral {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_neutral_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 67px;
    bottom: 8.5px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .sentiment-icon-negative {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_negative_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 67px;
    bottom: 8.5px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .contact-reason-group-topics-tab-info-pop-over {
    background: black;
    border: black !important;
    color: #FFFFFF;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  .topic-group-section-box {
    display: inline-flex;
    width: 100%;
    // height: calc(100vh - 278px);
    height: calc(100vh - 300px);
    // min-width: 1093px;

    .topic-group-section {
      min-width: 320px;
      width: 35%;
      padding: 14.5px 0px 15px 0px;
      background: #FFFFFF 0% 0% no-repeat padding-box;
      border: 1px solid #E8E8E8;
      border-radius: 10px 0px 0px 10px;
      opacity: 1;

      .div-group-viewer-content {
        margin-top: 10px;
        border-top: 1px solid #E8E8E8;
        border-bottom: 1px solid #E8E8E8;
        height: calc(100vh - 386px);
        overflow-y: auto;
        overflow-x: hidden;
        margin-bottom: 8px;
      }

      .div-group-viewer-header.div-group-name {
        font-size: 16px;
        font-weight: 500;
        padding: 0px 10px 4px 30px;
      }

      .div-group-topics {
        margin-top: 0px;

        .div-topic-content {
          height: fit-content;
          //padding-top: 10px;

          .div-item {
            display: flex;
            color: var(--site-font-primary-color);
            font-weight: normal;
            margin: 0px 0px 0px 0px;
            line-height: 19px;
            padding: 9px 28px 2px 30px;
            font-size: 12px;
            // width: 88%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;

            .div-ellipsis-item {
              flex: 90%;
              width: 88%;
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .div-messages-counter {
              flex: 10%;
              text-align: right;
            }
          }

          .div-item:hover {
            background: #f5f7fa;
          }

          .div-item.selected {
            background: #E2ECF7;
          }
        }
      }
    }
  }

  .div-group-viewer-footer.div-group-name {
    font-size: 16px;
    font-weight: 500;
    padding: 0px 0px 0px 0px;
  }

  .div-message-transcripts-viewer-footer {
    display: inline-block;
    width: 100%;

    .div-transcript-page-infor {
      float: left;
      padding-top: 2px;
      padding-left: 14px;
      font-size: 12px;
      color: #ADADAD;
    }

    .div-transcript-pagination {
      float: right;
      padding-right: 14px;
      font-size: 12px;
      color: #ADADAD;

      .el-pagination {
        padding-right: 0px;
      }

      .el-pagination button {
        color: #002852;
        font-weight: bold;
        padding-right: 0px;
        padding-left: 30px;
        font-size: 12px;
        line-height: unset !important;
        height: unset !important;

        >span {
          line-height: unset !important;
          height: unset !important;
        }
      }

      .el-pagination button:disabled {
        color: #C0C4CC;
      }

      .el-pagination span:not([class*=suffix]) {
        word-spacing: 7px;
      }
    }
  }
}

.contact-reason-group-topics-tab-info-pop-over {
  font-size: 13px;
  width: fit-content !important;
  box-shadow: 0px 0px 20px #0000002E;
  border-radius: 10px;
  color: #E4E8EC;
  line-height: 18px;
  padding: 12px 7px 10px 15px !important;

  .popper-item {
    margin-bottom: 15px;
  }

  .popper__arrow::after {
    display: block !important;
    border-top-color: #000 !important;
  }
}

.wy-analytics-contact-reasons-detail-topic-messages .message-transcripts-section {
  padding-top: 12px;
  min-width: 700px;

  .div-message-transcripts-viewer-header {
    padding: 6px 12px 4px 12px;
  }

  
  .div-message-transcripts-viewer-content {
    height: calc(100% - 68px);
  }

  .div-group-viewer-footer {
    border-top: 1px solid #E8E8E8;
  }

  .div-message-transcripts-viewer-footer {
    border-top: none;
    padding: 0px;
    padding-top: 7px;
  }

}
</style>